enum StoreNameEnum {
  System = 'system',
}

export default StoreNameEnum;
